var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[`btn btn-${_vm.__PROPtype}`, {'active': _vm.fb}],attrs:{"test-id":"button"},on:{"click":function($event){$event.preventDefault();return (() => _vm.__EMITpressed()).apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }